export enum AnomalieProperties {
    ID = 'id',
    ELEMENT = 'element',
}
